export const getastMonthCharges = (csrf_token) => {
    return fetch('/settings/last-month-charge/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrf_token,
        },
    });
};
